'use es6';

import * as EmailSubscriptionsApi from 'FormsUI/api/EmailSubscriptions';
const createAction = name => `@@emailSubscriptions/${name}`;
export const REQUEST_FETCH_EMAIL_SUBSCRIPTIONS = createAction('REQUEST_FETCH_EMAIL_SUBSCRIPTIONS');
export const SUCCEED_FETCH_EMAIL_SUBSCRIPTIONS = createAction('SUCCEED_FETCH_EMAIL_SUBSCRIPTIONS');
export const RECEIVE_EMAIL_SUBSCRIPTIONS = createAction('RECEIVE_EMAIL_SUBSCRIPTIONS');
export const FAIL_FETCH_EMAIL_SUBSCRIPTIONS = createAction('FAIL_FETCH_EMAIL_SUBSCRIPTIONS');
export const REQUEST_FETCH_EMAIL_SUBSCRIPTION_GROUPS = createAction('REQUEST_FETCH_EMAIL_SUBSCRIPTION_GROUPS');
export const SUCCEED_FETCH_EMAIL_SUBSCRIPTION_GROUPS = createAction('SUCCEED_FETCH_EMAIL_SUBSCRIPTION_GROUPS');
export const RECEIVE_EMAIL_SUBSCRIPTION_GROUPS = createAction('RECEIVE_EMAIL_SUBSCRIPTION_GROUPS');
export const FAIL_FETCH_EMAIL_SUBSCRIPTION_GROUPS = createAction('FAIL_FETCH_EMAIL_SUBSCRIPTION_GROUPS');
const requestFetchEmailSubscriptionsAction = () => ({
  type: REQUEST_FETCH_EMAIL_SUBSCRIPTIONS
});
const succeedFetchEmailSubscriptionsAction = () => ({
  type: SUCCEED_FETCH_EMAIL_SUBSCRIPTIONS
});
const receiveEmailSubscriptionsAction = payload => ({
  type: RECEIVE_EMAIL_SUBSCRIPTIONS,
  payload
});
const failFetchEmailSubscriptionsAction = () => ({
  type: FAIL_FETCH_EMAIL_SUBSCRIPTIONS
});
const requestFetchEmailSubscriptionGroupsAction = () => ({
  type: REQUEST_FETCH_EMAIL_SUBSCRIPTION_GROUPS
});
const succeedFetchEmailSubscriptionGroupsAction = () => ({
  type: SUCCEED_FETCH_EMAIL_SUBSCRIPTION_GROUPS
});
const receiveEmailSubscriptionGroupsAction = payload => ({
  type: RECEIVE_EMAIL_SUBSCRIPTION_GROUPS,
  payload
});
const failFetchEmailSubscriptionGroupsAction = () => ({
  type: FAIL_FETCH_EMAIL_SUBSCRIPTION_GROUPS
});
export const fetchEmailSubscriptions = (options = {}) => dispatch => {
  dispatch(requestFetchEmailSubscriptionsAction());
  return EmailSubscriptionsApi.fetchActiveSubscriptions(options).then(emailSubscriptions => {
    dispatch(succeedFetchEmailSubscriptionsAction());
    dispatch(receiveEmailSubscriptionsAction(emailSubscriptions));
  }).catch(err => {
    dispatch(failFetchEmailSubscriptionsAction());
    return err;
  });
};
export const fetchEmailSubscriptionGroups = () => dispatch => {
  dispatch(requestFetchEmailSubscriptionGroupsAction());
  return EmailSubscriptionsApi.fetchSubscriptionGroups().then(subscriptionGroups => {
    dispatch(succeedFetchEmailSubscriptionGroupsAction());
    dispatch(receiveEmailSubscriptionGroupsAction(subscriptionGroups));
  }).catch(err => {
    dispatch(failFetchEmailSubscriptionGroupsAction());
    return err;
  });
};